import { $t } from '@/i18n';
const getOrgSchema = () => ({
    id: 'org',
    title: $t('k_af37c0bd'),
    type: 'object',
    readonly: true,
    'uc:collapsed': true,
    'uc:bindable': false,
    methods: [
        {
            id: 'searchStaffs',
            title: $t('k_bdd1c828'),
            arguments: [
                { id: 'q', type: 'string', description: $t('k_91d0087a'), default: '' },
            ],
        },
        {
            id: 'fetchStaffs',
            title: $t('k_c2a35dfb'),
            arguments: [
                { id: 'userId', type: 'string', description: $t('k_de7a4c8b'), default: '' },
            ],
        },
    ]
});
export default getOrgSchema;
